export function VendorsFilter(vendors, vendor) {
  const vendorIndex = vendors.indexOf(vendor);
  if (vendorIndex > -1) {
    return vendors.splice(vendorIndex, 1);
  } else {
    return [...vendors, vendor];
  }
}
export function BrandsFilter(brands, brand) {
  const brandIndex = brands.indexOf(brand);
  if (brandIndex > -1) {
    return brands.splice(brandIndex, 1);
  } else {
    return brands.push(brand);
  }
}
